@if (isLoading()) {
  <div class="loader-background">
    <div class="loader-container">
      <!--<img class="logo" src="assets/logo/suite_logo_256.png" alt="logo" />-->
      <div class="icons-container">
        <!--<img src="../../../assets/pdf.svg" class="module-icon module-icon-pdf" />-->
        <div class="module-icon module-icon-map"></div>
        <!-- <div class="module-icon module-icon-editor"></div> -->
      </div>
      @if(progress() >= 0){
        <mat-progress-spinner class="spinner" diameter="40" [strokeWidth]="6"
          [mode]="progress() >= 0 && progress() <= 100 ? 'determinate' : 'indeterminate'"
          [value]="progress() >= 0 && progress() <= 100 ? progress() : undefined">
        </mat-progress-spinner>
      }
      <div class="message" translate>{{ message() }}</div>
    </div>
  </div>
}